import * as Types from '../constants/Types';
import { BOOKABLE_PACKAGE_RATE_ALL_SUCCESS } from './../constants/Types/BookablePackageRate';

const initialState = {
    isUpdating: false,
    isFail: false,
    dataList: [],
    isFetching: false,
    isFetchActive: false,
    isFetchSync: false,
    Detail : null,
    allList: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
      case Types.BOOKABLE_PACKAGE_RATE_ACTION:
        return { ...state, isFetching: true, dataList: [] };
      case Types.BOOKABLE_PACKAGE_RATE_SUCCESS:
        return {
          ...state,
          isFetching: false,
          dataList: action.dataList,
          isUpdating: false,
        };
      case Types.BOOKABLE_PACKAGE_RATES_SYNC_ACTION:
        return { ...state, isFetchSync: true, dataList: [] };
      case Types.BOOKABLE_PACKAGE_RATES_SYNC_SUCCESS:
        return { ...state, isFetchSync: false };
      case Types.BOOKABLE_PACKAGE_RATE_SYNC_ACTION:
        return { ...state, isFetchSync: true };
      case Types.BOOKABLE_PACKAGE_RATE_SYNC_SUCCESS:
        return { ...state, isFetchSync: false };
      case Types.BOOKABLE_PACKAGE_RATE_DETAIL_ACTION:
        return { ...state, isFetching: true, Detail: null };
      case Types.BOOKABLE_PACKAGE_RATE_DETAIL_SUCCESS:
        return { ...state, isFetching: false, isUpdating: false, Detail: action.result };
      case Types.BOOKABLE_PACKAGE_RATE_UPDATE_ACTION:
        return { ...state, isUpdating: true };
      case Types.BOOKABLE_PACKAGE_RATE_FAIL:
        return {
          ...state,
          isFetching: false,
          isFetchActive: false,
          isFetchSync: false,
          isUpdating: false,
        };
      case Types.BOOKABLE_PACKAGE_RATE_ALL_ACTION:
        return { ...state, isFetching: true, allList: [] };
      case Types.BOOKABLE_PACKAGE_RATE_ALL_SUCCESS:
          return {
            ...state,
            isFetching: false,
            allList: action.dataList,
          };
      default:
        return state;
    }
}
